export const advertisersRoutes = {
  path: '/advertisers',
  children: [
    {
      name: 'advertisers',
      path: '',
      component: () => import('pages/Advertisers/Advertisers/index.vue'),
      meta: {
        title: 'Advertisers',
      },
    },
    {
      name: 'newAdvertiser',
      path: 'new',
      component: () => import('pages/Advertisers/NewAdvertiser/index.vue'),
      meta: {
        title: 'New Advertisers',
      },
    },
    {
      name: 'editAdvertiser',
      path: ':id/edit',
      component: () => import('pages/Advertisers/EditAdvertiser/index.vue'),
      meta: {
        title: 'Edit Advertiser',
      },
    },
  ],
}
